import Vue from 'vue';
import Component from 'vue-class-component';
import ProductListContainer from '@/components/ProductListContainer/ProductListContainer';

@Component({
    components: {
        ProductListContainer
    }
})
export default class Unsecured extends Vue {
}
